/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ProductIdentityValueCreate } from './ProductIdentityValueCreate';
import type { RetailerId } from './RetailerId';

export type AggregatedProductIdentityCreate = {
    type: AggregatedProductIdentityCreate.type;
    values: Array<ProductIdentityValueCreate>;
    hasAutoCalculatedThresholds?: boolean;
    partialMatchThreshold?: number;
    fullMatchThreshold?: number;
    retailers: Array<RetailerId>;
};

export namespace AggregatedProductIdentityCreate {

    export enum type {
        SKU = 'SKU',
        NAME = 'NAME',
        AI = 'AI',
    }


}

